import { Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';

@Directive({ selector: '[appScrollToRecent]', standalone: false })
export class ScrollToRecentDirective implements OnChanges, OnDestroy {
  @Input() appScrollToRecent = false;
  private frameId?: number;

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  ngOnChanges(): void {
    if (this.frameId !== undefined) {
      cancelAnimationFrame(this.frameId);
      this.frameId = undefined;
    }
    if (!this.appScrollToRecent) return;

    this.frameId = requestAnimationFrame(() => {
      this.frameId = undefined;
      if (!this.appScrollToRecent) return;
      const row = this.element.nativeElement;
      if (row.getClientRects().length > 0) {
        row.scrollIntoView({ block: 'center', inline: 'nearest' });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.frameId !== undefined) cancelAnimationFrame(this.frameId);
  }
}
